import { useStaticQuery, graphql } from 'gatsby'
import { StringLiteralLike } from 'typescript'

export type markImageObject2 = {
  relativeDirectory: string;
  base: string;
  relativePath: string;
  publicURL: string;
  typeName: string;
}[];

export type markImageObject = {
  typeName: string;
  svg: string;
}[];



export const marksImagesMain = (): markImageObject => { 
  // const objectData: {
  //   mark: {
  //     edges: [
  //       {
  //         node: {
  //           relativeDirectory:string;
  //           base: string;
  //           relativePath: string;
  //           publicURL: string;
  //         }
  //       }
  //     ]
  //   }
  // } = useStaticQuery<{
  //   mark: {
  //     edges: [
  //       {
  //         node: {
  //           relativeDirectory:string;
  //           base: string;
  //           relativePath: string;
  //           publicURL: string;
  //         }
  //       }
  //     ]
  //   }
  // }>(
  //   graphql`
  //     query {
  //       mark:allFile(filter: {relativeDirectory: {glob: "type-mark"}}) {
  //         edges {
  //           node {
  //             relativeDirectory
  //             base
  //             relativePath
  //             publicURL
  //           }
  //         }
  //       }
  //     }
  //   `)
  
  const objectData: {
    allTypemarksJson: {
      nodes: [
        {
          type_name: string;
          svg: string;
        }
      ]
    }
  } = useStaticQuery<{
    allTypemarksJson: {
      nodes: [
        {
          type_name: string;
          svg: string;
        }
      ]
    }
  }>(graphql`
    query marks {
      allTypemarksJson {
        nodes {
          type_name
          svg
        }
      }
    }
  `)
  return objectData.allTypemarksJson.nodes.map(e => {
    return {
      typeName: e.type_name, 
      svg: e.svg
    }
  })





  // return objectData.allTypemarksJson.nodes
  // return objectData.mark.edges.map(e => {
  //   const newObj = {
  //     typeName: e.node.base.replace('.svg', ''), 
  //     ...e.node
  //   }
  //   return newObj
  // })
}

export default null
